  var app = angular.module("leonardo");

var TemplateListCalendar = function($scope, $state, ngDialog, $filter, $window, $timeout, TemplateService, AuthDataService,
                                    FilterService, AccountUserService, PermissionService) {

  $scope.templates = [];
  $scope.templateGroups = [];
  $scope.templateService = TemplateService;
  $scope.recurrence = TemplateService.RECURRENCE_DAILY;
  $scope.groupExpanded = [];

  $scope.setRecurrence = function(recurrence) {
    $scope.recurrence = recurrence;
    $scope.refresh();
  };

  $scope.toggleGroup = function(group, event) {
    angular.element('body').addClass('block-ui-visible');
    angular.element('body').addClass('block-ui-active');
    $timeout(function() {
      var index = $scope.groupExpanded.indexOf(group);
      if (index < 0) {
        $scope.groupExpanded.push(group);
      }
      else {
        $scope.groupExpanded.splice(index, 1);
      }
      angular.element('body').removeClass('block-ui-visible');
      angular.element('body').removeClass('block-ui-active');
      $timeout(function() {
        angular.element('.wrapper-columns-column.region-main .content-column').animate({scrollTop: angular.element(event.target).offset().top - 120}, "slow");
      }, 0);
    }, 0);
  };

  $scope.groupIsExpanded = function(group) {
    return _.contains($scope.groupExpanded, group);
  };

  $scope.disableToggleTemplate = function (template) {
    return (!template.editable && !template.overridable) ||
      !PermissionService.permissionAvailable('permission_edit_template');
  };

  $scope.getClasses = function (template) {
    var classes = [];
    if (template && !isNull(template.priority)) {
      switch (template.priority.toString()) {
        case TemplateService.PRIORITY_CRITICAL:
          classes.push('priority-critical');
          break;
        case TemplateService.PRIORITY_NORMAL:
          classes.push('priority-normal');
          break;
        case TemplateService.PRIORITY_MINOR:
          classes.push('priority-minor');
          break;
      }
    }
    return classes;
  };

  $scope.getColor = function (template) {
    var color = 'primaryColor';
    if (template && !isNull(template.priority)) {
      switch (template.priority.toString()) {
        case TemplateService.PRIORITY_CRITICAL:
          color = 'errorColor';
          break;
        case TemplateService.PRIORITY_NORMAL:
          color = 'warningColor';
          break;
        case TemplateService.PRIORITY_MINOR:
          color = 'tertiaryColor';
          break;
      }
    }
    return color;
  };

  $scope.isDeactivated = function(template) {
    return (template.status == TemplateService.STATUS_DEACTIVATED) ||
      (template.status == TemplateService.STATUS_UNPUBLISHED);
  };

  $scope.groupTemplates = function() {
  $scope.templateGroups = [];
    if (!isNull($scope.recurrence)) {
      switch ($scope.recurrence.toString()) {
        case TemplateService.RECURRENCE_DAILY:
          $scope.templateGroups.push({id: 'daily', name: 'Daily', templates: []});
          $scope.groupExpanded.push('daily');
          break;
        case TemplateService.RECURRENCE_WEEKLY:
          angular.forEach(TemplateService.RECURRENCE_WEEKLY_OPTIONS, function(value){
            $scope.templateGroups.push({id: value, name: value.name, templates: []});
            $scope.groupExpanded.push(value);
          });
          break;
        case TemplateService.RECURRENCE_MONTHLY:
          angular.forEach(TemplateService.RECURRENCE_MONTHLY_OPTIONS, function(value){
            $scope.templateGroups.push({id: value, name: $filter('weekName')(value), templates: []});
            $scope.groupExpanded.push(value);
          });
          break;
        case TemplateService.RECURRENCE_YEARLY:
          angular.forEach(TemplateService.RECURRENCE_YEARLY_OPTIONS, function(value, key){
            $scope.templateGroups.push({id: value, name: value, templates: []});
            $scope.groupExpanded.push(value);
          });
          break;
        default:
          return;
      }
    }
    angular.forEach($scope.templates, function(value){
      if (value.recurrence_type == TemplateService.RECURRENCE_DAILY) {
        angular.forEach($scope.templateGroups, function(group){
          group.templates.push(value);
        });
      }
      else if (value.recurrence_type == TemplateService.RECURRENCE_FIXED_DATE) {
        var date = moment(value.recurrence.date);
        if(value.recurrence.fixed_date_conditions) {
          date = moment(value.recurrence.fixed_date_conditions.date);
        }
        var month = date.format('MMMM');
        angular.forEach($scope.templateGroups, function(group) {
          if (month.toLowerCase() === group.id) {
            group.templates.push(value);
          }
        });
      }
      else {
        angular.forEach($scope.templateGroups, function(group){
          if (value.recurrence[group.id]) {
            group.templates.push(value);
          }
        });
      }
    });
  };

  $scope.getParams = function() {
    var filters = {disable_pagination: true};

    filters['recurrence_type'] = $scope.recurrence;
    if ($scope.recurrence == TemplateService.RECURRENCE_WEEKLY) {
      filters['recurrence_type'] += ',' + TemplateService.RECURRENCE_DAILY;
    }

    if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
      filters['type'] = TemplateService.TYPE_SYSTEM;
    }
    else if (FilterService.hasFilter('type')) {
      filters['type'] = FilterService.getFilter('type');
    }

    filters['account'] = FilterService.getFilter('account_reports');
    filters['client_instance'] = FilterService.getFilter('client_instances', true);

    var sector = AccountUserService.currentAccountUser ? AccountUserService.currentAccountUser.sector : null;
    filters['sector'] = FilterService.getFilter('sector') ? FilterService.getFilter('sector') : sector;

    if (FilterService.hasFilter('status')) {
      filters['status'] = FilterService.getFilter('status');
    }
    else {
      filters['status'] = TemplateService.STATUS_PUBLISHED + ',' + TemplateService.STATUS_UNPUBLISHED;
    }

    if (FilterService.hasFilter('property_reports')) {
      filters['property'] = FilterService.getFilter('property_reports');
    }
    else if (FilterService.hasFilter('portfolio_reports')) {
      filters['portfolio'] = FilterService.getFilter('portfolio_reports');
    }
    else if (FilterService.hasFilter('group_reports')) {
      filters['group'] = FilterService.getFilter('group_reports');
    }

    filters['category'] = FilterService.getFilter('category');

    filters['novice'] = FilterService.getFilter('novice');

    filters['ordering'] = 'status,-priority,name,type';

    return filters;
  };

  $scope.toggleActions = function (event) {
    var wrapper = angular.element(event.target).closest('.wrapper-actions');
    if (!wrapper.find('.actions').is(':visible'))
      angular.forEach(angular.element('.task-teaser .actions'), function (value) {
        angular.element(value).fadeOut();
      });
    var right = $(window).width() - (wrapper.find('icon').offset().left + wrapper.find('icon').width());
    if (right < 190)
      wrapper.find('.actions').css({right: 0});
    wrapper.find('.actions').fadeToggle();
    event.stopPropagation();
  };

  $scope.windowClick = function ($event) {
    angular.forEach(angular.element('.task-teaser .actions'), function (element) {
      if (($event.target == element[0]) || (angular.element(element).find($event.target).size() > 0)) {
        return false;
      }
    });
    angular.forEach(angular.element('.task-teaser .actions'), function (value) {
      angular.element(value).fadeOut();
    });
  };

  angular.element($window).on('click', $scope.windowClick);

  $scope.showPriorityDialog = function (template) {
    TemplateService.get(template.id).then(function (data) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/task/priority.html',
        controller: 'TaskPriorityDialog',
        data: {
          template: data,
          property: FilterService.getFilter('property_reports'),
          portfolio: FilterService.getFilter('portfolio_reports')
        }
      }).then(function(){
        $scope.refresh();
      });
    });
  };

  $scope.showRecurrenceDialog = function (template) {
    TemplateService.get(template.id).then(function (data) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/task/recurrence.html',
        controller: 'TaskRecurrenceDialog',
        data: {
          template: data,
          property: FilterService.getFilter('property_reports'),
          portfolio: FilterService.getFilter('portfolio_reports')
        }
      }).then(function () {
        $scope.refresh();
      });
    });
  };

  $scope.showEditTemplate = function (template) {
    if ($scope.disableToggleTemplate(template)) {
      return;
    }
    TemplateService.get(template.id).then(function (data) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/template/form.html',
        className: 'ngdialog-theme-default ngdialog-template-edit',
        controller: 'TemplateFormDialog',
        data: {
          template: data
        }
      }).then(function(){
        $scope.refresh();
      });
    });
  };

  $scope.fetchtemplates = function (value, exist) {
    angular.forEach($scope.templates, function (value_aux) {
      if ((value.id == value_aux.id)) {
        exist = true;
      }
    });
    if (!exist) {
      $scope.templates.push(value);
    }
  };

  $scope.refresh = function() {
    var params = $scope.getParams();
    TemplateService.getCalendar(params).then(function(data) {
      $scope.templates = [];
      angular.forEach(data.results, function(value){
        var exist = false;
        $scope.fetchtemplates(value, exist);
      });
      if ($scope.recurrence == TemplateService.RECURRENCE_YEARLY) {
        params['recurrence_type'] = TemplateService.RECURRENCE_FIXED_DATE;
        params['due_date__gte'] = moment().format('YYYY-MM-DD');
        TemplateService.getCalendar(params).then(function (data_fix) {
          angular.forEach(data_fix.results, function (value) {
            var exist = false;
            $scope.fetchtemplates(value, exist);
          });
          $scope.groupTemplates();
        });
      }
      else {
        $scope.groupTemplates();
      }
      if ($scope.templates.length === 0) {
        ngDialog.open({ template: 'views/templates/dialog/no-results.html'});
      }
    });
  };

  $scope.$on('filter-selection:updated', function(){
    $scope.refresh();
  });

  $scope.$on('templates-status:updated', function(){
    $scope.refresh();
  });

  $scope.$on('template:updated', function() {
    $scope.refresh();
  });

  $scope.$on('task-recurrence-dialog:success', function() {
    $scope.refresh();
  });

  $scope.$on('task-priority-dialog:success', function() {
    $scope.refresh();
  });

  $scope.$on('task-deactivate-dialog:success', function(){
    $scope.refresh();
  });

  $timeout(function() {
    if (AuthDataService.isNotStaff()) {
      $scope.refresh();
    }
  }, 100);

  $scope.$on('$destroy', function () {
    angular.element($window).off('click', $scope.windowClick);
  });

  $('.content-column').scroll(function () {
    $(this).find('.sticky').css({"position":"relative", "display":"inline-block", "left": $(this).scrollLeft()});
  });

};

app.controller('TemplateListCalendar', ['$scope', '$state', 'ngDialog', '$filter', '$window', '$timeout',
  'TemplateService', 'AuthDataService', 'FilterService', 'AccountUserService', 'PermissionService', TemplateListCalendar]);
